

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import {
  ActivationModel,
  IndividualModel,
  ServiceActivationModel,
} from '@/app/shared/models';
import CardIndividual from '@/app/shared/components/cards/individual.vue';
import DialogIndividual from '@/app/shared/components/dialogs/individual.vue';
@Component({ components: { CardIndividual, DialogIndividual } })
export default class ContentServiceComponent extends Vue {
  @Prop(Object) readonly data!: ActivationModel;
  @Prop(Array) readonly listData!: ServiceActivationModel[];

  private dialog = false;

  private get refs() {
    return refsService;
  }
  private get minDate() {
    return this.refs._.minBy(
      this.listData,
      (serviceActivation) => serviceActivation.StartDate
    );
  }
  private get listServiceActivation() {
    return this.refs._.without(this.listData, this.minDate);
  }

  private openDialogIndividual() {
    this.refs.modules.policy.SET_INDIVIDUAL(new IndividualModel());
    this.refs.modules.policy.SET_ACTIVATION(this.data);
    this.dialog = true;
  }
  private async closeDialogIndividual(individual: IndividualModel) {
    this.refs.modules.policy
      .createIndividual({
        policyId: this.refs.modules.policy.policy.Id,
        activationId: this.data.Id,
        individual,
      })
      .then(() => {
        this.$toast(this.$t('toasts.create_individual_successfully'));
        this.refs.services.policy
          .getActivationById(this.refs.modules.policy.policy.Id, this.data.Id)
          .then((res) => {
            this.$emit('update', res);
            this.dialog = false;
          });
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.create_individual_error'));
      });
  }
}
